import styles from "./css/DropDownMenu.module.css";

interface DropDownMenuProps {
  value: string;
  color?: string;
  handleOnClick: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export default function DropDownMenu(props: DropDownMenuProps) {
  return (
    <>
      <div className={styles.container} onClick={props.handleOnClick}>
        {props.color === undefined && (
          <span className={styles.valueText}>{props.value}</span>
        )}
        {props.color !== undefined && (
          <span
            className={styles.valueText}
            style={{
              color: props.color,
            }}
          >
            {props.value}
          </span>
        )}
        {props.color === undefined && (
          <img className={styles.rightArrowImage} src="iconImgAllBack.png" alt="" />
        )}
        {props.color !== undefined && (
          <img
            alt=""
            className={styles.rightArrowImage}
            src="iconImgAllBack.png"
            style={{
              color: props.color,
            }}
          />
        )}
      </div>
    </>
  );
}
